const UserCreateAccountSelectManager = {
  'pages_user_components_CustomerInfoChangeInfo.validation_registCompanyName': '회사명을 입력하십시오.',
  'pages_user_components_CustomerInfoChangeInfo.validation_first_name': '명을 입력하십시오.',
  'pages_user_components_CustomerInfoChangeInfo.validation_last_name': '성을 입력하십시오.',
  'pages_user_components_CustomerInfoChangeInfo.modify_receive': '수신 설정이 수정되었습니다.',
  'pages_user_components_CustomerInfoChangeInfo.title': '사용자 정보 수정',
  'pages_user_components_CustomerInfoChangeInfo.validation': '핸드폰 번호의 유형이 맞지 않습니다.',
  'pages_user_components_CustomerInfoChangeInfo.validation_email': 'Email의 유형이 맞지 않습니다.',
  'pages_user_components_CustomerInfoChangeInfo.modify_user': '권한이 수정되었습니다.',
  'pages_user_components_CustomerInfoChangeInfo.modify_security': '보안 설정이 수정되었습니다.'
}

export default UserCreateAccountSelectManager



// WEBPACK FOOTER //
// ./src/lang/user/components/CustomerInfoChangeInfo.kr.js